export const messages = {
  edit: { id: 'admin/promotions.utils.edit' },
  remove: { id: 'admin/promotions.utils.remove' },
  connector: {
    and: { id: 'admin/promotions.form.rule.connector.and' },
    or: { id: 'admin/promotions.form.rule.connector.or' },
    with: { id: 'admin/promotions.form.rule.connector.with' },
  },
}
